import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

const filingCabinetSearchParamKey = 'fc';

const useFilingCabinetKeyInCurrentURL = (): readonly [number | undefined, (key: number | null, asReplace?: boolean) => void, string, URLSearchParams] => {
    const { pathname } = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    const filingCabinetKey = useMemo(() => {
        const fcKey = searchParams.get('fc');
        return fcKey != null ? Number.parseInt(fcKey) : undefined;
    }, [searchParams]);

    const setFilingCabinetKey = (key: number | null, asReplace = true): void => {
        setSearchParams((prev) => {
            prev.delete(filingCabinetSearchParamKey);

            if (key) {
                prev.append(filingCabinetSearchParamKey, key.toString());
            }

            return prev;
        }, { replace: asReplace });
    };

    const urlWithoutParams = useMemo(() => {
        return pathname;
    }, [pathname]);

    const searchParamsWithoutFilingCabinetKey = useMemo(() => {
        const params = searchParams;
        params.delete(filingCabinetSearchParamKey);

        return params;
    }, [searchParams]);

    return [filingCabinetKey, setFilingCabinetKey, urlWithoutParams, searchParamsWithoutFilingCabinetKey] as const;
};

export default useFilingCabinetKeyInCurrentURL;
